import React, {useId, useState} from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material'
import {useSessionControls} from './SessionContext'

export default function ReplaceHostButton() {
  const controls = useSessionControls()
  const [generation, setGeneration] = useState<number | null>(null)
  const titleId = useId()
  const descriptionId = useId()
  return <>
    <Button disabled={controls.busy || !controls.hostGeneration} onClick={() => setGeneration(controls.hostGeneration ?? null)}>Replace host</Button>
    <Dialog open={generation !== null} onClose={() => setGeneration(null)} aria-labelledby={titleId} aria-describedby={descriptionId}>
      <DialogTitle id={titleId}>Replace current host?</DialogTitle>
      <DialogContent><DialogContentText id={descriptionId}>This tab will take over the published tournament progress. The current host will lose control.</DialogContentText></DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => setGeneration(null)}>Cancel</Button>
        <Button disabled={controls.busy} onClick={() => {const expected = generation; setGeneration(null); if (expected !== null) void controls.resume(expected)}}>Replace host</Button>
      </DialogActions>
    </Dialog>
  </>
}
